import React, { useEffect } from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { makeStyles } from '@material-ui/core/styles';
import Main from '@/layouts/Main';
import { fetchTaxonomyMenus } from '@/actions/menu';
import { fetchMenusTaxonomy } from '@/actions/menuTaxonomy';
import BottomBanner from '@/components/common/BottomBanner';
import MenuTaxonomyCategoryListContainer from '@/containers/menus/MenuTaxonomyCategoryListContainer';
import MenuModalContainer from '@/containers/menus/MenuModalContainer';
import MenuTaxonomyListContainer from '@/containers/menus/MenuTaxonomyListContainer';
import styles from 'styles/jss/original/pages/menus-taxonomy/slug';
import _ from 'lodash';
import basicAuthentication from '@/lib/basicAuthentication';
import Head from '@/components/common/Head';
import { SITE_TITLE, SITE_DESCRIPTION } from '@/config/meta';
import useMenuTaxonomy from '@/hooks/useMenuTaxonomy';
import { wrapper, AppDispatch } from '@/store/configureStore';
import { Query } from '@/hooks/useMenuTaxonomy';

type ComponentProps = {
  query: Query;
};

// @ts-expect-error
const useStyles = makeStyles(styles);

const MenuTaxonomyPage: NextPage<ComponentProps> = ({ query }) => {
  const classes = useStyles();
  const router = useRouter();
  const [taxonomy, error] = useMenuTaxonomy(query);
  useEffect(() => {
    if (error) {
      _.defer(() => router.replace('/404'));
    }
  }, [error, router]);
  if (error || !taxonomy) return null;
  return (
    <>
      <div className={classes.page}>
        <Main>
          <Head
            title={`「${taxonomy.fields.title}」献立 | ${SITE_TITLE}`}
            description={`「${taxonomy.fields.title}」献立 | ${SITE_DESCRIPTION}`}
            image={taxonomy.fields.thumbnail.fields.file.url}
            url={`https://smalldish.jp/menus-taxonomy/${query.slug}`}
          />
          <div className={classes.main}>
            <MenuTaxonomyListContainer query={query} />
            <MenuTaxonomyCategoryListContainer />
            <BottomBanner />
          </div>
          <MenuModalContainer />
        </Main>
      </div>
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(async ({ query, store, req, res }) => {
  if (!process.browser) {
    basicAuthentication({ req, res });
  }
  await Promise.all([
    (store.dispatch as AppDispatch)(fetchTaxonomyMenus(query.slug)),
    (store.dispatch as AppDispatch)(fetchMenusTaxonomy())
  ]);
  return { props: { query } };
});

export default MenuTaxonomyPage;
